import { HttpErrorResponse } from '@angular/common/http';
import { ILegalFormExtendedDTO } from '@modeso/types__aumico-lib-settings-be';
import { EntityState } from '@ngrx/entity';

export interface ILegalFormState extends EntityState<ILegalFormExtendedDTO> {
    activeLegalForm?: ILegalFormExtendedDTO;
    error?: HttpErrorResponse;
}
